import { claimTypeValues } from '@/common/constants'

export const claimTypeChip = {
  [claimTypeValues.carrierMarkedDeliveredNotReceived]: {
    label: 'Entrega sin completar',
  },
  [claimTypeValues.possiblyLostNoTrackingUpdates]: {
    label: 'Paquete posiblemente perdido - Seguimiento sin actualizaciones recientes',
  },
  [claimTypeValues.deliveredDamagedOrMissingItems]: {
    label: 'Entrega con daños visibles o productos faltantes',
  },
  [claimTypeValues.packageHeldAtCustoms]: {
    label: 'Paquete retenido en aduanas',
  },
}
